// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"fc9b4dbe","344":"0fd2edaa","438":"387cc76a","706":"49bf240f","726":"3abc4530"}[chunkId] + ".chunk.js";
};